<ng-container
  *ngrxLet="remoteDiagnosticsStore.selectIsChartUncollapsed$ | async as isChartUncollapsed"
>
  <!-- Mobile header -->
  <div class="mobile-header lt-md:!flex flex-row justify-between items-stretch !hidden">
    <div class="flex flex-row gap-[8px]">
      <div
        *ngIf="numberOfSelectedSensorVdds > 0 || isAnySeriesValid"
        class="flex flex-row gap-[8px] justify-start items-center"
      >
        <mat-icon>bar_chart</mat-icon>
        <span class="bold">{{ 'DIAGNOSTICS.INFOGRAPHIC' | translate }}</span>
      </div>
      <app-pill *ngIf="isAnyParameterRunning$ | async" [type]="pillType.brand">{{
        'DIAGNOSTICS.STICKY_MENU.LIVE_BADGE' | translate
      }}</app-pill>
    </div>
    <div class="chart-menu__collapse">
      <mat-icon *ngIf="!isChartUncollapsed" (click)="changeChartVisibility()"
        >keyboard_arrow_up</mat-icon
      >
      <mat-icon *ngIf="isChartUncollapsed" (click)="changeChartVisibility()"
        >keyboard_arrow_down</mat-icon
      >
    </div>
  </div>

  <app-diagnostics-chart
    class="chart-wrapper"
    [class.chart-visible]="isChartUncollapsed"
  ></app-diagnostics-chart>
  <!-- Desktop view -->

  <div class="chart-menu lt-md:!hidden">
    <div class="flex flex-row gap-[8px] justify-start items-center">
      <div
        *ngIf="numberOfSelectedSensorVdds > 0 || isAnySeriesValid"
        class="flex flex-row gap-[8px] justify-start items-center"
      >
        <mat-icon>bar_chart</mat-icon>
        <span class="bold">{{ 'DIAGNOSTICS.INFOGRAPHIC' | translate }}</span>
      </div>
      <app-pill *ngIf="isAnyParameterRunning$ | async" [type]="pillType.brand">{{
        'DIAGNOSTICS.STICKY_MENU.LIVE_BADGE' | translate
      }}</app-pill>
    </div>
    <div class="chart-menu__empty"></div>
    <div class="chart-menu__params">
      <mat-checkbox
        [disabled]="!(allVisibleParameters$ | async)"
        [(ngModel)]="isAllParametersSelected"
        class="management-tab-container__checkbox"
        (change)="allParameterSelectionChange($event)"
      >
        <span>
          {{ 'DIAGNOSTICS.STICKY_MENU.PARAMETERS' | translate }} ({{
            allSelectedParameters$ | async
          }}/{{ allVisibleParameters$ | async }})
        </span>
      </mat-checkbox>
    </div>
    <div
      class="chart-menu__manage"
      *ngrxLet="isAnyParameterRunningAndSelected$ as isAnyParameterRunningAndSelected"
      [class.chart-menu__manage--active]="isAnyParameterRunningAndSelected"
    >
      <mat-form-field>
        <mat-select
          [disabled]="isAnyParameterRunningAndSelected"
          [(value)]="interval"
          (selectionChange)="onIntervalChange($event)"
        >
          <mat-option
            *ngFor="let i of remoteDiagnosticsStore.getAvailableIntervals$ | async"
            [value]="i"
            gtm="onSelect"
            gtmAction="Set interval to all selected - value picked: '{{ i }}'"
            gtmCategory="diagnosticsPageHeader"
          >
            {{ i | msToSeconds }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <!-- icons / not running -->
      <ng-container *ngIf="!isAnyParameterRunningAndSelected">
        <mat-icon
          class="icon"
          [class.disabled]="
            !interval ||
            !(
              remoteDiagnosticsStore.isAnyParameterStoppedAndSelectedAndNotInError(gatewaySerial)
              | async
            ) ||
            (remoteDiagnosticsStore.isAnyParameterLoading(gatewaySerial) | async) ||
            (remoteDiagnosticsStore.scheduleMultipleParametersReadCycleInProgress$ | async)
          "
          (click)="startReadingChartParameters()"
          >fiber_manual_record</mat-icon
        >
      </ng-container>
      <!-- icons / running -->
      <ng-container *ngIf="isAnyParameterRunningAndSelected">
        <mat-icon
          class="icon"
          [class.disabled]="!isAnyParameterRunningAndSelected"
          (click)="stopReadingParameters()"
          >stop</mat-icon
        >
      </ng-container>
      <img
        *ngIf="isAnySeriesValid"
        icon
        (click)="deleteSeries()"
        class="icon"
        src="assets/icons/eraser.svg"
      />
    </div>
    <div class="chart-menu__collapse">
      <mat-icon *ngIf="!isChartUncollapsed" (click)="changeChartVisibility()"
        >keyboard_arrow_up</mat-icon
      >
      <mat-icon *ngIf="isChartUncollapsed" (click)="changeChartVisibility()"
        >keyboard_arrow_down</mat-icon
      >
    </div>
  </div>
  <!-- Mobile view -->
  <div class="chart-menu flex-col !hidden lt-md:!flex">
    <div
      class="chart-menu__manage"
      *ngrxLet="isAnyParameterRunningAndSelected$ as isAnyParameterRunningAndSelected"
      [class.chart-menu__manage--active]="isAnyParameterRunningAndSelected"
    >
      <mat-form-field>
        <mat-select
          [disabled]="isAnyParameterRunningAndSelected"
          [(value)]="interval"
          (selectionChange)="onIntervalChange($event)"
        >
          <mat-option
            *ngFor="let i of remoteDiagnosticsStore.getAvailableIntervals$ | async"
            [value]="i"
            gtm="onSelect"
            gtmAction="Set interval to all selected - value picked: '{{ i }}'"
            gtmCategory="diagnosticsPageHeader"
          >
            {{ i | msToSeconds }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <!-- icons / not running -->
      <ng-container *ngIf="!isAnyParameterRunningAndSelected">
        <mat-icon
          class="icon"
          [class.disabled]="
            !interval ||
            !(
              remoteDiagnosticsStore.isAnyParameterStoppedAndSelectedAndNotInError(gatewaySerial)
              | async
            ) ||
            (remoteDiagnosticsStore.isAnyParameterLoading(gatewaySerial) | async) ||
            (remoteDiagnosticsStore.scheduleMultipleParametersReadCycleInProgress$ | async)
          "
          (click)="startReadingChartParameters()"
          >fiber_manual_record</mat-icon
        >
      </ng-container>
      <!-- icons / running -->
      <ng-container *ngIf="isAnyParameterRunningAndSelected">
        <mat-icon
          class="icon"
          [class.disabled]="!isAnyParameterRunningAndSelected"
          (click)="stopReadingParameters()"
          >stop</mat-icon
        >
      </ng-container>
      <img
        *ngIf="isAnySeriesValid"
        icon
        (click)="deleteSeries()"
        class="icon"
        src="assets/icons/eraser.svg"
      />
    </div>
  </div>
</ng-container>
